module.exports = __webpack_public_path__ + "officialStatic/img/cou2.28b6d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/cou2.png
// module id = nERb
// module chunks = 0